import _ from "@lodash";
import { Typography, withStyles } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import FirebaseAuthService from "app/Core/services/FirebaseAuthService";
import classNames from "classnames";
import clsx from "clsx";
import * as Helpers from 'app/Core/Helpers'
import React from "react";

const styles = (theme) => ({
   root: {
      background: theme.palette.type === "dark" ? "#424242" : "#E6E6E6",
      color: theme.palette.primary.contrastText,
   },
   paper: {
      width: "70%",
   },
   image: {
      display: "flex",
      "@media (max-width: 960px)": {
         display: "none",
      },
   },
   bgTheme: {
      backgroundColor: theme.palette.primary.main
   }
});

class Logout extends XAPPComponent {

   componentDidMount() {
      Helpers.checkRedirectAuth();
      FirebaseAuthService.Logout();
   }

   render() {
      const { classes, theme, user, location } = this.props;

      return (
         <React.Fragment>
            <div className={classNames(classes.root, "flex flex-col flex-1 flex-no-shrink p-0 md:flex-row")}>
               <div
                  className={clsx(
                     classes.image,
                     "flex-col flex-no-grow items-center text-white p-16 text-center md:p-128 md:flex-no-shrink md:flex-1 md:text-left justify-center"
                  )}
               >
                  <div className={classes.paper}>
                     <Typography color="textSecondary" variant="h4" className="text-center">Redirecionando para a autenticação... </Typography>
                     <img
                        className={clsx(classes.bgTheme, "justify-center")}
                        src={`https://storage.googleapis.com/hexapp-public/logos/${document.location.hostname}/logo_${theme.palette.type}.png`}
                        alt="Logo principal"
                     />
                  </div>
               </div>
            </div>
         </React.Fragment>
      );
   }
}

export default withStyles(styles, { withTheme: true })(Logout);
